import { styled } from 'linaria/react';
import { css } from 'linaria';

export const ComplementaryProductsBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ComplimentaryProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  width: 100%;
`;

export const ComplimentaryProductImg = styled.img`
  min-width: 128px;
  width: 100%;
  max-width: 128px;
  margin: 0 var(--space-400) 0 var(--space-200);
  cursor: pointer;
  object-fit: fill;

  @media (--only-tablet) {
    margin: 0 var(--space-300) 0 var(--space-100);
  }
  @media (--only-mobile) {
    min-width: 78px;
    max-width: 78px;
    margin: 0 var(--space-200) 0 var(--space-100);
  }
`;

export const AddedProductsTitle = styled.div`
  margin: var(--space-400) 0 var(--space-300) 0;
`;

export const ComplimentaryProductInfoBlock = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-200);
  }
`;

export const ComplimentaryProductInfoTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: var(--space-75);
  width: 27.5%;
  margin-left: auto;

  & > div {
    justify-content: flex-end;

    @media (--only-mobile) {
      justify-content: flex-start;
    }
  }

  @media (max-width: 1100px) {
    width: 35.5%;
  }

  @media (--only-mobile) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const ComplimentaryProductInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 100%;
`;

export const ComplimentaryProductInfoRow = styled.div`
  display: flex;

  @media (--only-mobile) {
    flex-direction: column;
    gap: var(--space-100);
  }
`;

export const CounterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (--only-mobile) {
    justify-content: flex-start;
  }
`;
export const ComplementaryProductInfoWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  width: 100%;
  max-width: 214px;
  @media (max-width: 1100px) {
    max-width: 180px;
  }
  @media (--to-tablet) {
    align-items: flex-start;
    max-width: 100%;
  }
`;

export const ComplimentaryItemLink = css`
  text-align: 'justify';
  cursor: 'pointer';
`;
